module.exports = __webpack_public_path__ + "img/nationalities.56fbf54b.png";